import type { IProjectRepository, ProjectListOptions } from '../repositories/IProjectRepository.js';
import type { ProjectEntity } from '../entities/ProjectEntity.js';

interface Deps { projectRepository: IProjectRepository; }

export function createListProjectsUseCase({ projectRepository }: Deps) {
  return async function listProjects(options?: ProjectListOptions): Promise<{ data: ProjectEntity[]; total: number }> {
    return projectRepository.list(options);
  };
}
